import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { FiLock } from 'react-icons/fi';
import { INFLUENCER_RESCHEDULE_CUTOFF_HOURS } from '@foodfluence/shared';
import { SheetButton, SheetFooter } from '../../components/counter-flow/sheetParts';
import WizardSheet from './WizardSheet';

interface Within24HoursErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
  message?: string;
  /** The locked visit ("Sat, Oct 24 · 2:00 PM") and where, for the board's lock card. */
  visitLabel?: string;
  visitSub?: string;
}

const DEFAULT_MESSAGE =
  'Rescheduling is now closed for this collab. Please contact the brand if you would like to reschedule.';

// Name kept for callers; the cutoff it explains is INFLUENCER_RESCHEDULE_CUTOFF_HOURS (3h), not 24h.
const Within24HoursErrorModal: React.FC<Within24HoursErrorModalProps> = ({ isOpen, onClose, message, visitLabel, visitSub }) => (
  <WizardSheet
    isOpen={isOpen}
    onClose={onClose}
    title={`Can't change within ${INFLUENCER_RESCHEDULE_CUTOFF_HOURS}h of your visit`}
  >
    {visitLabel && (
      <Flex p="14px" borderRadius="16px" bg="#F2F2F0" align="center" gap="12px" mb="16px">
        <Flex flex="none" w="44px" h="44px" borderRadius="12px" bg="#FFFFFF" align="center" justify="center" aria-hidden>
          <FiLock size={20} strokeWidth={2.2} />
        </Flex>
        <Box minW={0}>
          <Text fontSize="15px" fontWeight={600} lineHeight="normal">{visitLabel}</Text>
          {visitSub && <Text fontSize="13px" color="#55555A" lineHeight="normal" noOfLines={1}>{visitSub}</Text>}
        </Box>
      </Flex>
    )}
    <Text m={0} fontSize="15px" lineHeight="1.45" color="#3E3E42">
      {message ?? DEFAULT_MESSAGE}
    </Text>
    <SheetFooter>
      <SheetButton onClick={onClose}>Got it</SheetButton>
    </SheetFooter>
  </WizardSheet>
);

export default Within24HoursErrorModal;
